<template>
    <div id="app" :class="isOnLogin ? 'on-login' : ''">
        <menu-component v-model="menuVisible"/>
        <header-component v-if="headerVisible" @menuClick="onMenuClick"/>
        <alert-component v-if="!isOnLogin" id="alert"></alert-component>
        <router-view id="page"></router-view>
        <navigation-component @alarmClick="popupVisible = true" v-if="navigationVisible"/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import HeaderComponent from './components/header.component.vue';
    import NavigationComponent from '@/components/navigation.component.vue';
    import MenuComponent from '@/components/menu.component.vue';
    import AlertComponent from '@/components/alert.component.vue'
    import {Viewport, RouteName, AppConfig, Role} from './utils/enums'
    import axios from 'axios';
    import SockJS from "sockjs-client";
    import Stomp from "webstomp-client";

    const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

    export default Vue.extend({
        name: 'app',
        components: {
            HeaderComponent,
            NavigationComponent,
            MenuComponent,
            AlertComponent
        },
        data() {
            return {
                menuVisible: false,
                popupVisible: false,
                websocketConnected: false,
                socket: {},
                stompClient: {}
            };
        },
        mounted() {
          this.connectWebsocket();
        },
        methods: {
            onMenuClick() {
                this.menuVisible = true;
            },
          /**
           *  Een Meldkamer medewerker subscribed op /all om alle alarmeringen te ontvangen.
           *  Een Zorgprofessional subscribed op de /{id} van zijn woonlocatie zodat alleen alarmeringen
           *  van zijn woonlocatie binnenkomen.
           */
            connectWebsocket() {
              let user = this.$store.getters.getUserDetails;
              const userIsMeldkamerMedewerker = user.groups.some(groupName => groupName === Role.MELDKAMER_MEDEWERKER);
              const userIsZorgProfessional = user.groups.some(groupName => groupName === Role.ZORG_PROFESSIONAL);
              let wsSubscriptionEndpoint;
              if (userIsMeldkamerMedewerker || userIsZorgProfessional) {
                if (userIsMeldkamerMedewerker) {
                  wsSubscriptionEndpoint = '/all';
                } else {
                  axios.get(`${apiUrl}${AppConfig.API_EMPLOYEES_URL}/getLocationId/${user.oid}`)
                  .then(res => {
                    wsSubscriptionEndpoint = `/${res.data}`;
                });
                }
                setTimeout(() => {
                  this.socket = new SockJS(apiUrl + AppConfig.API_WEBSOCKET_REGISTER_URL);
                  this.stompClient = Stomp.over(this.socket);
                  this.stompClient.connect({}, () => {
                        this.websocketConnected = true;
                        this.stompClient.subscribe(`${AppConfig.API_WEBSOCKET_NOTIFICATIONS_URL}${wsSubscriptionEndpoint}`,
                            notification => {
                              this.$store.dispatch('RECEIVED_NEW_NOTIFICATION', notification.body);
                            });
                      },
                      error => {
                        console.error(error);
                      }
                  );
                }, 5000); // timeout om benodigde data te verzamelen
              }
            },
        },
        computed: {
            isOnLogin() {
                return this.$route.name === RouteName.LOGIN;
            },
            navigationVisible() {
                if (this.isOnLogin) {
                    return false;
                }

                // @ts-ignore
                if (this.$mq === Viewport.DESKTOP) {
                    return true;
                }

                const routeLayout = this.$route.meta.layout;
                return routeLayout && routeLayout.nav.visible;
            },
            routeLayout() {
                return this.$route.meta.layout;
            },
            authRequired() {
                return this.$route.meta.authRequired;
            },
            headerVisible() {
                const routeLayout = this.$route.meta.layout;


                if (
                    this.$mq === Viewport.DESKTOP &&
                    this.$route.name === RouteName.HOME ||
                    this.$route.name === RouteName.CONNECT_COMPLETE
                ) {
                    return false;
                }

                return routeLayout && routeLayout.header.visible;
            }
        },
    });
</script>

<style lang="scss">
    #app {
        display: flex;
        flex-direction: column;
        height: 100%;

        @include desktop {
            padding-left: 100px;
        }

        &.on-login {
            padding-left: 0;
        }
    }

    #alert {
        margin-left: auto;
    }

    #page {
        flex-grow: 1;
        padding: 1rem;

        @include desktop {
            padding: 2rem;
        }
    }
</style>
